import { render } from "./Muddemaal.vue?vue&type=template&id=a8418c64&scoped=true"
import script from "./Muddemaal.vue?vue&type=script&lang=js"
export * from "./Muddemaal.vue?vue&type=script&lang=js"

import "./Muddemaal.vue?vue&type=style&index=0&id=a8418c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8418c64"]])

export default __exports__